/**
 * API Service - Backend API endpoints
 */

import { http } from '@/network/http';
import type { LoginCredentials, RegisterData } from '@/features/auth/types';

export const authApi = {
  login: (credentials: LoginCredentials) =>
    http.post('/auth/login', credentials),

  register: (data: RegisterData) =>
    http.post('/auth/register', data),

  sendOtp: (email: string) =>
    http.post('/auth/register/send-otp', { email }),

  verifyOtp: (email: string, code: string) =>
    http.post('/auth/register/verify-otp', { email, code }),

  refresh: () =>
    http.post('/auth/refresh'),

  logout: () =>
    http.post('/auth/logout'),

  logoutAll: () =>
    http.post('/auth/logout-all'),

  getMe: () =>
    http.get('/auth/me'),

  forgotPassword: (data: { email: string }) =>
    http.post('/auth/forgot-password', data),

  resetPassword: (data: { token: string; password: string }) =>
    http.post('/auth/reset-password', data),

  googleSignIn: (credential: string, preferredLanguage?: string) =>
    http.post('/auth/google-signin', { credential, preferredLanguage }),

  googleCallback: (code: string, redirectUri?: string, preferredLanguage?: string) =>
    http.post('/auth/google/callback', { code, redirect_uri: redirectUri, preferredLanguage }),

  getGoogleConfig: () =>
    http.get('/auth/google-config'),

  appleSignIn: (identityToken: string, user?: { name?: { firstName?: string; lastName?: string } }, preferredLanguage?: string) =>
    http.post('/auth/apple-signin', { identityToken, user, preferredLanguage }),

  getAppleConfig: () =>
    http.get('/auth/apple-config'),
};
